import {ValidationErrorKeys} from '@hconnect/common/consts'
import {type TFunction} from 'i18next'
import {object, string} from 'yup'

const TEXT_MAX_LENGTH = 256
const COMMENT_MAX_LENGTH = 512

export const getHousekeepingSectionValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    lancingFloorsTimeCleaned: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    lancingFloorsComment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    ),
    coolerFloorTimeCleaned: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    coolerFloorTimeComment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    ),
    burnerFloorTimeCleaned: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    burnerFloorTimeComment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    ),
    shiftExpectationAreasTimeCleaned: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    shiftExpectationComment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    ),
    coolerRoofAtHoodTimeCleaned: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    coolerRoofAtHoodComment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    )
  })
